import { useFlags } from 'launchdarkly-react-client-sdk';
import evaluateDispensaryFeatureFlag from 'shared/utils/evaluate-dispensary-feature-flag';
export default function useDispensaryFlag(key, dispensaryId) {
    var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var flags = useFlags();
    var featureFlagValue = flags[key];
    return evaluateDispensaryFeatureFlag(key, featureFlagValue, dispensaryId, defaultValue);
}
